import { useFeatureFlagEnabled } from 'posthog-js/react';
import type { ReviewCard } from '@/types/gtm-agents';

/** The consent split; the API's `clu_builder_v2` reads the same key. */
export const CONSENT_SPLIT_FLAG = 'clu_builder_v2';

/**
 * A proposal's review card: the steps that spend credits or reach outside
 * the account, which Accept confirms. `card` is what to show and send
 * (`consentBody`); `held` while the API sent a card the flag doesn't show
 * yet (it is still loading), so Accept never confirms a card nobody saw.
 */
export function useReviewCard(
  proposal: { reviewCard?: ReviewCard | null } | undefined
) {
  const on = useFeatureFlagEnabled(CONSENT_SPLIT_FLAG) === true;
  const card = proposal?.reviewCard?.items.length ? proposal.reviewCard : null;
  return { card: on ? card : null, held: Boolean(card) && !on };
}

/** The accept body's confirmation of `card`, nothing without one. */
export const consentBody = (card: ReviewCard | null | undefined) =>
  card ? { consent: card.digest } : {};
